import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-check',
    templateUrl: './check.component.svg',
    styleUrls: ['./check.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckComponent {}
